import { CreditReportRequestType } from '../services/corelogic'

export const ALFIE_CREDIT_ORDER_STATUS = {
  Ordered: 'ordered',
  Held: 'held',
  Failed: 'failed',
  Existing: 'existing',
} as const

export type AlfieCreditOrderStatus =
  (typeof ALFIE_CREDIT_ORDER_STATUS)[keyof typeof ALFIE_CREDIT_ORDER_STATUS]

export const ALFIE_CREDIT_HOLD_REASON = {
  CoBorrowerSsnMissing: 'co_borrower_ssn_missing',
  CoBorrowerConsentMissing: 'co_borrower_consent_missing',
} as const

export type AlfieCreditHoldReason =
  (typeof ALFIE_CREDIT_HOLD_REASON)[keyof typeof ALFIE_CREDIT_HOLD_REASON]

export const ALFIE_CREDIT_FAILURE_REASON = {
  PrimarySsnMissing: 'primary_ssn_missing',
  PrimaryConsentMissing: 'primary_consent_missing',
  CreditOrderFailed: 'credit_order_failed',
} as const

export type AlfieCreditFailureReason =
  (typeof ALFIE_CREDIT_FAILURE_REASON)[keyof typeof ALFIE_CREDIT_FAILURE_REASON]

export type AlfieCreditOrderResult =
  | {
      status: typeof ALFIE_CREDIT_ORDER_STATUS.Ordered
      creditPullType: 'soft' | 'hard'
      requestType: CreditReportRequestType
    }
  | {
      status: typeof ALFIE_CREDIT_ORDER_STATUS.Held
      reasons: AlfieCreditHoldReason[]
    }
  | {
      status: typeof ALFIE_CREDIT_ORDER_STATUS.Failed
      reason: AlfieCreditFailureReason
    }
  | {
      status: typeof ALFIE_CREDIT_ORDER_STATUS.Existing
    }
